import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const GigMultiplePage = loadable(
  () => import(
    /* webpackChunkName: "multi-shift-page-chunk" */
    './GigMultiplePage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default GigMultiplePage;
